<template>
  <div class="hero-badge fade-in-up">
    <span v-if="showDot" class="badge-dot"></span>
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'HeroBadge',
  props: {
    text: {
      type: String,
      required: true
    },
    showDot: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 24px;
  letter-spacing: 0.5px;

  .badge-dot {
    width: 8px;
    height: 8px;
    background: #4ade80;
    border-radius: 50%;
    animation: pulse-dot 2s ease-in-out infinite;
  }
}
</style>
